import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type { UpsertFeedingInput } from "@shared/validation/feeding.schema";
import { apiClient, ApiError } from "./client";

export interface FeedingProfileData {
  id: string;
  childId: string;
  dietType: string | null;
  restrictions: string | null;
  likes: string | null;
  dislikes: string | null;
  portionNotes: string | null;
  scheduleNotes: string | null;
  bottleFormula: string | null;
  utensilsNotes: string | null;
  createdAt: string;
  updatedAt: string;
}

const feedingKey = (childId: string) => ["children", childId, "feeding"] as const;

export function useFeeding(childId: string | undefined) {
  return useQuery<FeedingProfileData | null, ApiError>({
    queryKey: childId ? feedingKey(childId) : ["children", "__none__", "feeding"],
    queryFn: () => apiClient<FeedingProfileData | null>(`/api/feeding/${childId}`),
    enabled: Boolean(childId),
  });
}

export function useSaveFeeding(childId: string) {
  const queryClient = useQueryClient();
  return useMutation<FeedingProfileData, ApiError, UpsertFeedingInput>({
    mutationFn: (vars) =>
      apiClient<FeedingProfileData>(`/api/feeding/${childId}`, {
        method: "PUT",
        body: JSON.stringify(vars),
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: feedingKey(childId) });
    },
  });
}
